module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "jarviswidget jarviswidget-color-darken",
    attrs: {
      "role": "widget"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    attrs: {
      "role": "content"
    }
  }, [_c('div', {
    staticClass: "widget-body no-padding"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped table-condensed table-hover has-tickbox"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', [(_vm.loading) ? _c('tr', [_vm._m(3)]) : _vm._l((_vm.models), function(model) {
    return _c('tr', [_c('td', [_vm._v(" " + _vm._s(model.id) + " ")]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "10%"
      }
    }, [_vm._v(" " + _vm._s(model.number) + " ")]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "1%"
      }
    }, [_vm._v(" " + _vm._s('-') + " ")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(model.status) + " ")]), _vm._v(" "), _c('td', [(model.status !== 'MergeAuthorizationProtocolCompleted') ? _c('a', {
      staticClass: "btn btn-default",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.cancelar(model.id)
        }
      }
    }, [_vm._v("Cancelar")]) : _vm._e(), _vm._v(" "), (model.status === 'MergeAuthorizationProtocolCompleted') ? _c('span', [_c('a', {
      staticClass: "btn btn-success",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.download(model.id, 'pdf')
        }
      }
    }, [_vm._v("PDF")]), _vm._v(" "), _c('a', {
      staticClass: "btn btn-primary",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.download(model.id, 'xml')
        }
      }
    }, [_vm._v("XML")])]) : _vm._e()])])
  })], 2)])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "page-title txt-color-blueDark"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-archive"
  }), _vm._v(" \r\n          Notas Fiscais\r\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    attrs: {
      "role": "heading"
    }
  }, [_c('h2', [_c('strong', [_c('i', {
    staticClass: "fa fa-archive"
  }), _vm._v("\r\n                Lista de Notas Fiscais\r\n              ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Nº Nota")]), _vm._v(" "), _c('th', [_vm._v("Data")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v("Ações")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "5"
    }
  }, [_c('div', {
    staticClass: "fa-3x"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]), _vm._v("\r\n                        Aguarde, carregando notas fiscais.\r\n                      ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-441fc436"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Resources/NotasFiscaisList.vue
// module id = 1000
// module chunks = 1